import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";
import * as types from "../../../constants/actionTypes";
import * as msgs from "../../../constants/textConstants";
import { Tooltip } from "../../ecosystem";
import { CircleButtonCard } from "../../ecosystem/mybswh";
import DashboardSectionHeading from '../DashboardSectionHeading';
import GetCareButton from './GetCareButton';

const GetCareTile = ({
    history,
    showGetCareTileToolTip,
    openActionBarToolTip,
    isMobile,
    disabled,
    clearSearch,
    collapsed,
    screenBreakPoint
}) => {

    const handleTileClick = (tileName, routeName = '') => {
        logUI(`MBHWeb.UI.GetCareTile.${tileName}.Clicked`, new Date(), Tools.getURLPath());
        if (routeName) {
            history.push(routeName);
        }
    }

    const tooltipText = "Hey there! “Get Care” is now your home for scheduling appointments as well as finding a new doctor or location.";

    const tooltipLinkText = "Continue";

    const collapseBtn = (collapsed && screenBreakPoint === msgs.XS_MOBILE) && "circle";

    return (
        <Tooltip open={showGetCareTileToolTip}
            text={tooltipText}
            tooltipId="getcare-tooltip"
            linkText={tooltipLinkText}
            variant="spotlight"
            linkOnClick={
                () => {
                    openActionBarToolTip();
                }
            }
            placement={collapsed ? "bottom-start" : "top" }
        >
            <div className={`refresh-get-care-tile-wrapper ${isMobile ? 'refresh-get-care-tile-wrapper--mobile' : ''}`}>
                {
                    collapsed || isMobile
                        ? <GetCareButton
                            fluid
                            icon="medical"
                            label={<span class='getCareLabel'>Schedule<span class="getCareLabel_Extended"> & Search</span></span>}
                            variant={collapseBtn}
                            onClick={
                                    () => {
                                        handleTileClick("Schedule & Search", "/schedulesearch");
                                    }
                                }
                            />
                        : <div className="row">
                            <div className="col-12">
                                <DashboardSectionHeading
                                    heading="Schedule & Search"
                                    mBottom="sm"
                                />
                                <div className="row get-care-card-wrapper">
                                    <div className="col-6">
                                        <CircleButtonCard cardIcon={
                                            { name: 'appointments', set: 'brand' }
                                        }
                                            disabled={disabled}
                                            to={"/schedulenow"}
                                            onClick={
                                                () => {
                                                    handleTileClick("ScheduleNow");
                                                }
                                            }
                                            title="Schedule Now"
                                            body="Book an appointment with your doctor, schedule a video visit, and more."
                                            bodyStyle={{ type: 'body-02' }}
                                            titleStyle={{type:'heading-03'}}
                                        />
                                    </div>
                                    <div className="col-6">
                                        <CircleButtonCard cardIcon={
                                            { name: 'meet-our-team', set:'brand' }
                                        }
                                            to={"/findcare"}
                                            onClick={
                                                () => {
                                                    handleTileClick("FindCare");
                                                    clearSearch();
                                                }
                                            }
                                            title="Find Care"
                                            body="Search for the right doctor, location, or type of care for you."
                                            bodyStyle={{ type: 'body-02' }}
                                            titleStyle={{ type: 'heading-03' }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                } </div>
        </Tooltip>
    );
}

const mapStateToProps = (state) => {
    return {
        hasMyChart: state.domain.hm,
        screenBreakPoint: state.common.screenBreakPoint,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        clearSearch: () => {
            dispatch({ type: types.SEARCH_PROVIDER_CLEAR });
            dispatch({ type: types.SEARCH_LOCATION_CLEAR });
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GetCareTile));
